import { render, staticRenderFns } from "./bookingList.vue?vue&type=template&id=70dfa6d7&scoped=true"
import script from "./bookingList.vue?vue&type=script&lang=js"
export * from "./bookingList.vue?vue&type=script&lang=js"
import style0 from "./bookingList.vue?vue&type=style&index=0&id=70dfa6d7&prod&lang=less&scoped=true"
import style1 from "./bookingList.vue?vue&type=style&index=1&id=70dfa6d7&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70dfa6d7",
  null
  
)

export default component.exports